import React from "react";
import PropTypes from "prop-types";

class Modal extends React.Component {
  modalRef = null;
  skipPropFunc = false;

  componentDidMount() {
    $(this.modalRef).on("hide.bs.modal", () => {
      if (this.skipPropFunc) {
        this.skipPropFunc = false;
      } else {
        if (this.props.skipInitialClose != true) {
          this.props.onClose();
        };
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.visible !== this.props.visible) {
      if (nextProps.visible) {
        $(this.modalRef).modal("show");
      } else {
        this.skipPropFunc = true;
        $(this.modalRef).modal("hide");
      }
    }
  }

  componentWillUnmount() {
    $(this.modalRef).modal("hide");
  }

  render() {
    const { title, subTitle, children, allContent } = this.props;

    return (
      <div
        tabIndex="0"
        role="dialog"
        className="modal fade"
        ref={el => (this.modalRef = el)}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <a
              className="pull-right close-button link-color pointer-hand"
              tabIndex="0"
              role="button"
              data-dismiss="modal"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  $(this.modalRef).modal("hide");
                }
              }}
            >
              <i className="material-icons md-35">close</i>
            </a>
            <div className="modal-header">
              <h1 className="modal-title word-wrap">{title}</h1>
              {subTitle && (
                <p className="modal-sub-title center-text">{subTitle}</p>
              )}
            </div>
            <div className="modal-body">{children}</div>
          </div>
        </div>
      </div>
    );
  }
}

Modal.propTypes = {
  visible: PropTypes.bool,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  onClose: PropTypes.func
};

export default Modal;
